var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon / X"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.4676 4.24219H20.2277L14.1976 11.0196L21.2915 20.2422H15.7371L11.3866 14.6488L6.40873 20.2422H3.64694L10.0967 12.993L3.2915 4.24219H8.98695L12.9194 9.35481L17.4676 4.24219ZM16.4988 18.6176H18.0283L8.15591 5.78147H6.5147L16.4988 18.6176Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.d940060f06039897e5f5aabf4d9ae35e.svg";
export { ForwardRef as ReactComponent };